export enum LogLevel {
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4
}

export enum LogType {
  Console,
  Server
}
